import { NgModule } from '@angular/core';

import { NovoCampanhaMultiselectModule } from '../../../../../../domains/shared/components/novo-campanha-multiselect/novo-campanha-multiselect.module';
import { NovoCanalMidiaSocialMultiSelectModule } from '../../../../../../domains/shared/components/novo-canal-midia-social-multi-select/novo-canal-midia-social-multi-select.module';
import { NovoCanalVendaMultiSelectModule } from '../../../../../../domains/shared/components/novo-canal-venda-multi-select/novo-canal-venda-multi-select.module';
import { NovoClienteGrupoEconomicoSelectModule } from '../../../../../../domains/shared/components/novo-cliente-grupo-economico-select/novo-cliente-grupo-economico-select.module';
import { NovoEstadoMultiselectModule } from '../../../../../../domains/shared/components/novo-estado-multiselect/novo-estado-multiselect.module';
import { NovoOrigemMultiSelectModule } from '../../../../../../domains/shared/components/novo-origem-multi-select/novo-origem-multi-select.module';
import { NovoPeriodicidadeCompraMultiSelectModule } from '../../../../../../domains/shared/components/novo-periodicidade-compra-multi-select/novo-periodicidade-compra-multi-select.module';
import { NovoPessoaTipoMultiselectModule } from '../../../../../../domains/shared/components/novo-pessoa-tipo-multiselect/novo-pessoa-tipo-multiselect.module';
import { NovoRegiaoMultiselectModule } from '../../../../../../domains/shared/components/novo-regiao-multiselect/novo-regiao-multiselect.module';
import { NovoSemanaMultiSelectModule } from '../../../../../../domains/shared/components/novo-semana-multi-select/novo-semana-multi-select.module';
import { NovoTypeaheadCidadeModule } from '../../../../../../domains/shared/components/novo-typeahead-cidade/novo-typeahead-cidade.module';
import { NovoTypeaheadClienteCentralCompraModule } from '../../../../../../domains/shared/components/novo-typeahead-cliente-central-compra/novo-typeahead-cliente-central-compra.module';
import { SharedModule } from '../../../../../../shared';
import { ClienteAnaliseFinanceiraStatusMultiselectModule } from '../../../analise-financeira/status/multiselect';
import { NovoClienteFilterAvancadoComponent } from './novo-cliente-filter-avancado.component';

@NgModule({
  imports: [
    SharedModule,
    NovoPessoaTipoMultiselectModule,
    NovoClienteGrupoEconomicoSelectModule,
    NovoCampanhaMultiselectModule,
    NovoOrigemMultiSelectModule,
    NovoCanalVendaMultiSelectModule,
    NovoCanalMidiaSocialMultiSelectModule,
    NovoRegiaoMultiselectModule,
    NovoEstadoMultiselectModule,
    NovoTypeaheadCidadeModule,
    NovoTypeaheadClienteCentralCompraModule,
    ClienteAnaliseFinanceiraStatusMultiselectModule,
    NovoPeriodicidadeCompraMultiSelectModule,
    NovoSemanaMultiSelectModule
  ],
  declarations: [NovoClienteFilterAvancadoComponent],
  exports: [NovoClienteFilterAvancadoComponent]
})
export class NovoClienteFilterAvancadoModule {}
